import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslate } from 'src/localization/Trns'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { css } from 'styled-components'

interface TransactionSyncStatusFilterProps {
  syncStatusesSet: Set<string>
  handleSyncStatusesSelection: (status: string) => Set<string>
  activeIntegration: any
}

const TransactionSyncStatusFilter: React.FC<
  TransactionSyncStatusFilterProps
> = ({ syncStatusesSet, handleSyncStatusesSelection, activeIntegration }) => {
  const translate = useTranslate()
  const showBulkErpAttachments = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_bulk_erp_attachments

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate(
          showBulkErpAttachments
            ? 'Transaction Sync'
            : '${platformName} Sync Status',
          {
            platformName: activeIntegration?.platformName || '',
          },
        )}
      </div>
      <Checkbox
        label={translate('Synced')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Success)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Success)}
      />
      <Checkbox
        label={translate('Not synced')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.NotSynced)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.NotSynced)}
      />
      <Checkbox
        label={translate('Sync failed')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Failed)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Failed)}
      />
      <Checkbox
        label={translate('Sync in progress')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Pending)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Pending)}
      />
    </div>
  )
}

export default TransactionSyncStatusFilter
